import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import styles from "./index.module.scss";
import Props from "/components/common/product/props";
import Offer from "/components/common/product/offer";
import Icon from "/components/common/icon";
import Picture from "./picture";
import { showPopup } from "/redux/action-creaters/popup";
import { popupTypes } from "/redux/reducers/popupReducer";
import Files from "/components/pages/product/files";
import { declOfNum, formatType } from "../../../../utils";
import Sert from "../../product/sert";

export default function Product({
  data,
  delivery,
  managerDataNew,
  managerComment,
  managerInstall,
  viewType,
  isBaltex,
  isLanding = false,
  reviewsCount,
  questionsCount,
}) {
  const dispatch = useDispatch();
  const { cityName } = useSelector((state) => state.location);
  const { sections } = useSelector((state) => state.sections);

  const images = data.PHOTOS_NEW?.filter((item, index) => {
    if (isBaltex) {
      return data.PHOTO_DESCRIPTIONS[index] === "#схема#";
    }
    return true;
  }).map((pictureId) => {
    const path1 = pictureId.substr(0, 2);
    const path2 = pictureId.substr(2, 2);
    const path3 = pictureId.substr(4);
    return `/images/${path1}/${path2}/${path3}/small.webp`;
  });

  return (
    <div
      className={clsx(
        isBaltex && styles.ProductBaltex,
        isLanding && styles.ProductLanding,
        styles.Product,
        viewType === 1 && styles.ProductTable,
      )}
      itemScope
      itemType="http://schema.org/Product"
      onClick={() => {
        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line no-undef
        dataLayer.push({
          ecommerce: {
            currencyCode: "RUB",
            click: {
              products: [
                {
                  id: data.ID,
                  name: data.NAME,
                  price: data.CATALOG?.MIN_PRICE,
                  category: sections[data.IBLOCK_SECTION_ID].NAME,
                  brand: data.BRAND?.name,
                  list: "Каталог",
                },
              ],
            },
          },
        });
      }}
    >
      <div className={styles.Left}>
        <Link href={data.DETAIL_PAGE_URL ?? "/"}>
          <a className={styles.Name} itemProp="url">
            <span itemProp="name">{formatType(data.NAME)}</span>
          </a>
        </Link>
        <span style={{ display: "none" }} itemProp="description">
          {data.NAME}
        </span>
        {Boolean(managerComment) && (
          <span
            style={{ color: "red" }}
            dangerouslySetInnerHTML={{ __html: managerComment }}
          ></span>
        )}
        <div className={styles.Photos}>
          {data.DETAIL_PAGE_URL && (
            <Picture
              isBaltex={isBaltex}
              stick={data.STICK}
              name={data.NAME}
              alt={`${data.NAME} ${data.ARTICLE?.VALUE} в ${cityName}`}
              link={data.DETAIL_PAGE_URL ?? "/"}
              video={data.VIDEO}
              path={data.DETAIL_PAGE_URL}
              images={images}
            />
          )}
          {data.PROPERTIES?.FILES_JSON?.VALUE && (
            <a
              href={data.PROPERTIES.FILES_JSON?.VALUE}
              rel="noreferrer"
              target="_blank"
              className={styles.File}
            >
              <Icon id="pdf" width={18} height={20} />
              <span>Инструкция по установке</span>
            </a>
          )}
          <Sert file={data.SERT} />
          {false && !isBaltex && !isLanding && (
            <div
              className={styles.FastView}
              onClick={() => {
                dispatch(showPopup(popupTypes.fastView, data.CODE));
              }}
            >
              Быстрый просмотр
            </div>
          )}
        </div>
        <div className={styles.Info}>
          {delivery && <div className={styles.Delivey}>{delivery}</div>}
          {Boolean(managerDataNew) && (
            <div
              className={styles.ManagerData}
              dangerouslySetInnerHTML={{ __html: managerDataNew }}
            />
          )}
          {!isBaltex && (
            <div className={styles.Art}>Артикул {data.ARTICLE?.VALUE}</div>
          )}
          <div className={styles.Props}>
            <Props
              props={data.PROPERTIES}
              filterUrl={data.FILTER_URL}
              isBaltex={isBaltex}
            />
          </div>
          <div className={styles.Files}>
            <Files file={data.FILE} isBaltex={isBaltex} />
            <Sert sert={data.SERT} isBaltex={isBaltex} />
          </div>
        </div>
      </div>
      <div className={styles.Right}>
        {data.CATALOG && (
          <Offer
            product={data}
            isBaltex={isBaltex}
            managerInstall={managerInstall}
          />
        )}

        <div className={styles.Communicate}>
          {reviewsCount > 0 ? (
            <div
              onClick={() => {
                dispatch(
                  showPopup(popupTypes.productReviews, {
                    name: data.NAME,
                    link: data.DETAIL_PAGE_URL,
                    id: data.ID,
                  }),
                );
                if (typeof ym !== "undefined") {
                  // eslint-disable-next-line no-undef
                  ym(20518312, "reachGoal", "listPageReviews");
                }
              }}
            >
              <Icon id="comment" width={15} height={14} fill={"#ffa500"} />
              {`${declOfNum(reviewsCount, ["отзыв", "отзыва", "отзывов"])} о товаре`}
            </div>
          ) : (
            <div
              style={styles.FormButton}
              onClick={() =>
                dispatch(
                  showPopup(popupTypes.addReview, {
                    id: data.ID,
                  }),
                )
              }
            >
              <Icon id="comment" width={15} height={14} fill={"#ffa500"} />
              Оставить отзыв
            </div>
          )}
          {questionsCount > 0 ? (
            <div
              onClick={() => {
                dispatch(
                  showPopup(popupTypes.productQuestions, {
                    name: data.NAME,
                    link: data.DETAIL_PAGE_URL,
                    id: data.ID,
                  }),
                );
                if (typeof ym !== "undefined") {
                  // eslint-disable-next-line no-undef
                  ym(20518312, "reachGoal", "listPageQuestions");
                }
              }}
            >
              <Icon id="question" width={15} height={14} fill={"#ffa500"} />
              {`${declOfNum(questionsCount, ["вопрос", "вопроса", "вопросов"])} о товаре`}
            </div>
          ) : (
            <div
              style={styles.FormButton}
              onClick={() =>
                dispatch(
                  showPopup(popupTypes.addQuestion, {
                    id: data.ID,
                  }),
                )
              }
            >
              <Icon id="question" width={15} height={14} fill={"#ffa500"} />
              Задать вопрос
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
